import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Injectable } from '@angular/core';
import { apis, HttpRequestSettings } from '@sb-shared/models/request-settings';
import { map } from 'rxjs/operators';

const baiduMapsHost = 'map.baidu.com';

/**
 * True when the URL's host is the Baidu Maps host, or a subdomain of it.
 *
 * Parses the URL rather than searching the raw string: a substring test matches
 * 'map.baidu.com' anywhere, so 'https://evil.com/?x=map.baidu.com' and
 * 'https://map.baidu.com.evil.com/' would both be treated as Baidu.
 * Unparseable input is not Baidu.
 */
export function isBaiduMapsUrl(url: string): boolean {
  try {
    const host = new URL(url).hostname;
    return host === baiduMapsHost || host.endsWith(`.${baiduMapsHost}`);
  } catch {
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class InstallationSettingsService {

  baseUrl = 'WebInstallationSettings/';
  config: HttpRequestSettings = {
    api: apis.Web
  };

  constructor(private http: HttpWebApiService) { }

  getDefaultColours() {
    return this.http.get(this.baseUrl + 'GetDefaultColours', this.config).pipe(map(data => {
      const colours = data;
      return { primaryColour: colours.defaultPrimaryColour, secondaryColour: colours.defaultSecondaryColour };
    }))
  }

  getMapsUrl(){
    return this.http.get(this.baseUrl + 'GetMapsUrl', this.config)
      .pipe(map(response => {
          const url = response.mapsURL;
          const isBaidu = isBaiduMapsUrl(url);
          return { value: url, label: isBaidu ? '百度地图' : 'SB_Google_Maps', isBaidu: isBaidu };
      }));
  }
}
